import { IconProps } from '../types';

function ViewListNoSymbolSolidIcon({ className, id }: IconProps) {
  return (
    <svg
      id={id}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      className={className || 'h-5 w-5'}
    >
      <path
        fillRule="evenodd"
        d="M3 4c0-.6.4-1 1-1h12c.6 0 1 .4 1 1s-.4 1-1 1H4c-.6 0-1-.4-1-1zm0 4c0-.6.4-1 1-1h12c.6 0 1 .4 1 1s-.4 1-1 1H4c-.6 0-1-.4-1-1zm0 4c0-.6.4-1 1-1h4c.6 0 1 .4 1 1s-.4 1-1 1H4c-.6 0-1-.4-1-1zm0 4c0-.6.4-1 1-1h4c.6 0 1 .4 1 1s-.4 1-1 1H4c-.6 0-1-.4-1-1zm11.5-6C12 10 10 12 10 14.5s2 4.5 4.5 4.5 4.5-2 4.5-4.5-2-4.5-4.5-4.5zm0 2c.3 0 .6.1.9.2l-3.2 3.2c-.1-.3-.2-.6-.2-.9 0-1.4 1.1-2.5 2.5-2.5zm0 5c-.3 0-.6-.1-.9-.2l3.2-3.2c.1.3.2.6.2.9 0 1.4-1.1 2.5-2.5 2.5z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default ViewListNoSymbolSolidIcon;
